export default "__VITE_ASSET__DwVGKSxp__"